import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace/apply-admin-namespace-to-content.js'
import { readTemplate } from './read-template.js'

export function readNamespacedTemplate(relativePath: string, namespace: string): string {
  return applyAdminNamespaceToContent(readTemplate(relativePath), namespace)
}
